// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__Ag7_a","content":"GlobalSearch_content__fU4dR"};